import type { ItemMetaData } from '../dto/fieldValue';

export const DEFAULT_MDF_ID = 'default';
export const RESTRICTED_MATERIAL_MDF_ID = 'default_restricted';
export const DETECTED_TEXT_MDF_ID = 'default_detected_text';
export const TECHNICAL_IMAGE_DATA_MDF_ID = 'default_image';
export const TECHNICAL_VIDEO_DATA_MDF_ID = 'default_video';
export const TECHNICAL_AUDIO_DATA_MDF_ID = 'default_audio';
export const TECHNICAL_DATA_FLAVOR = 'technical_data';
export const DEFAULT_SCENE_DETECTION_MDF_ID = 'default_scene_detection';
export const FOLDER_DEFAULT_MDF_ID = 'default_folder';

export const FOLDER_MDF_LABEL = 'Folder Common';

export const DEFAULT_METADATA_FORM_IDS: readonly string[] = [
  DEFAULT_MDF_ID,
  RESTRICTED_MATERIAL_MDF_ID,
  DETECTED_TEXT_MDF_ID,
  TECHNICAL_IMAGE_DATA_MDF_ID,
  TECHNICAL_VIDEO_DATA_MDF_ID,
  TECHNICAL_AUDIO_DATA_MDF_ID,
  FOLDER_DEFAULT_MDF_ID,
];

export const DEFAULT_TITLE = 'New item';

/**
 * Current known system default fields.
 */
export enum SystemDefaultField {
  Title = 'default_title',
  Description = 'default_description',
  CreatedOn = 'default_createdOn',
  MediaCreatedOn = 'default_mediaCreatedOn',
}

export interface PayloadInitializationOptions {
  title?: string;
  createdOn?: string;
  formId?: string | null;
}

export const createNewPayload = (options: PayloadInitializationOptions): ItemMetaData => {
  const { title, createdOn, formId } = options;
  return {
    formId: formId ?? DEFAULT_MDF_ID,
    formData: {
      [SystemDefaultField.Title]: title ?? DEFAULT_TITLE,
      ...(createdOn && { [SystemDefaultField.CreatedOn]: createdOn })
    }
  };
};
